import React from 'react';
import MotifButton from '../BaseComponentWrappers/MotifButton';
import MotifIcon from '@ey/motif-react-wrapper/Icon';
import styled from 'styled-components';
import { IconoirTrash, IconoirArrowLeft, IconoirArrowRight, IconoirXmark } from '@ey-xd/motif-icon';
import { labels } from '../../../util/utils';
import MotifIconButton from '@ey/motif-react-wrapper/IconButton';

const startPointButtonList = [
    {
        id: 2,
        type: 'pointer'
    },
    {
        id: 1,
        iconName: IconoirArrowLeft,
        type: 'arrow'
    }
]

const endPointButtonList = [
    {
        id: 2,
        type: 'pointer'
    },
    {
        id: 1,
        iconName: IconoirArrowRight,
        type: 'arrow'
    }
]

const EdgePropertiesPopup = ({ removeEdge, handleDropdownClose, handleEdgePropertyUpdate, activeButton }) => {
    return (
        <Wrapper>
            <section className="arrow">&nbsp;</section>
            <p className="header">
                <span className="title motif-label4-default-regular">{labels.flowChartNewSteps.edgeConnectorOptions}</span>
                <MotifButton variant="text" className="close-icon" onClick={handleDropdownClose} type="button">
                    <MotifIcon
                        src={IconoirXmark}
                        size="20"
                        title={labels.closeLabel}
                    />
                </MotifButton>
            </p>
            <section className='edge-property-section'>
                <section className='edge-type-label motif-body3-default-light'>{labels.flowChartNewSteps.edgeStartPoint}</section>
                <section className="buttonwrapper">
                    {
                        startPointButtonList.map((button, index) => {
                            return (
                                <section className={button.id === activeButton.startActiveButton ? 'parent active' : 'parent'} key={index}>
                                    <MotifButton variant="text" onClick={() => handleEdgePropertyUpdate('source', button.id)} type="button" disabled={button.id === activeButton.startActiveButton ? true : false}>
                                        <MotifIcon
                                            className={button.type === 'pointer' ? "circle-startpoint" : ""}
                                            src={button.type === 'arrow' ? button.iconName : ""}
                                            size="16"
                                        />
                                    </MotifButton>
                                </section>
                            )
                        })
                    }
                </section>
            </section>
            <section className='edge-property-section'>
                <section className='edge-type-label motif-body3-default-light'>{labels.flowChartNewSteps.edgeEndPoint}</section>
                <section className="buttonwrapper">
                    {
                        endPointButtonList.map((button, index) => {
                            return (
                                <section className={`${button.id === activeButton.endActiveButton ? 'parent active' : 'parent'}`} key={index}>
                                    <MotifButton variant="text" onClick={() => handleEdgePropertyUpdate('target', button.id)} type="button"  disabled={button.id === activeButton.endActiveButton ? true : false}>
                                        <MotifIcon
                                            className={button.type === 'pointer' ? "circle-endpoint" : ""}
                                            src={button.type === 'arrow' ? button.iconName : ""}
                                            size="16"
                                        />
                                    </MotifButton>
                                </section>
                            )
                        })
                    }
                </section>
            </section>
            <section className="btn-wrapper">
            <MotifButton
                variant="text"
                onClick={removeEdge}
                type={'button'}
                className="delete"
            >
                <MotifIcon src={IconoirTrash} size="20" />
                <span className="title motif-label3-default-regular">{labels.flowChartNewSteps.deleteConnector}</span>
            </MotifButton>
            </section>
        </Wrapper>
    );
};

export default EdgePropertiesPopup;

const Wrapper = styled.section`
    padding: var(--spacing-medium);
    background: var(--neutrals-900);
    width: var(--px-200);
    border-radius:  var(--border-radius-small);
    border: var(--border-width-small) solid transparent;

    .edge-property-section {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: var(--spacing-medium-large); 
         .edge-type-label {
            color: var(--neutrals-25);
        }
        .buttonwrapper{
            display: flex;
            margin-left: auto;
        }
        .parent{
            width: var(--px-24);
            height: var(--px-24);
            padding: var(--px-5) var(--px-3);
            display: flex;
            .circle-startpoint {
                width: var(--px-8);
                height: var(--px-8);
                border-radius: 50%;
                position: relative;
                background: var(--neutrals-00white);
                display: flex;
                margin-left: var(--px-3);
            }

            .circle-startpoint::after {
                content: '';
                position: absolute;
                top: 44%; /* Adjust this value to center the line */
                left: var(--px-4);
                width: 100%;
                height: var(--px-2);
                background-color: var(--neutrals-00white);
            }

             .circle-endpoint {
                width: var(--px-8);
                height: var(--px-8);
                border-radius: 50%;
                position: relative;
                background: var(--neutrals-00white);
                display: flex;
                margin-left: var(--px-6);
            }

            .circle-endpoint::after {
                content: '';
                position: absolute;
                top: 44%; /* Adjust this value to center the line */
                right: var(--px-4);
                width: 100%;
                height: var(--px-2);
                background-color: var(--neutrals-00white);
            }

            &.active{
                background: var(--blue-600);
            }

            &:first-child{
                margin-right: var(--spacing-small);
            }

            .motif-button{
                svg,
                path{
                    fill: var(--neutrals-00white);
                    width: var(--px-16);
                    height: var(--px-16);
                }
            }
        } 
    }

    &::before{
        content: '';
            position: absolute;
            top: calc(var(--px-10) * -1);
            left: 45%;
            width: 0;
            height: 0;
            border-left: var(--px-12) solid transparent;
            border-right: var(--px-12) solid transparent;
            border-bottom: var(--px-16) solid var(--neutrals-900);
            }

    .header{
        margin: 0;
        border-bottom: var(--border-width-small) solid var(--neutrals-800);
        padding-bottom: var(--spacing-small);
        margin-bottom: var(--spacing-medium-large);
        display: flex;
        .close-icon{
            margin-left: auto;
            path{
                fill: var(--neutrals-00white);
            }
        }
        .title{
            display: flex;
            align-items: center;
            color: var(--neutrals-25);
        }
        .motif-button{
            margin-left: auto;
        svg{
            fill: var(--neutrals-25);
        }
        }
    }
        
    .arrow{ 
        width: 0;
        height: 0;
        border-left: var(--px-8) solid transparent;
        border-right: var(--px-8) solid transparent;
        border-bottom: var(--px-8) solid vvar(--neutrals-900);
        position: absolute;
        top: calc(var(--px-7) * -1);
        left: 50%;
    }

    .btn-wrapper{
        width: 100%;
        border-top: var(--border-width-small) solid var(--neutrals-800);
        padding-top: var(--spacing-small); 
    }

    .delete{
        margin: 0 auto;
        gap: var(--spacing-small);
        .title{
            color: var(--blue-200)!important;
        }
        .motif-icon{
            svg{
                color: var(--blue-200)!important;
            }
        }
    }
`;
